@if (heading) {
    <h2 class="chooser-label">{{ heading }}</h2>
}
<div class="row g-3 mt-1">
    @for (choice of choices; track choice.route) {
        <div class="col-sm-6 col-lg-4">
            <a class="chooser-card" [routerLink]="choice.route">
                <span class="chooser-card__icon"><i class="fa {{ choice.icon }}" aria-hidden="true"></i></span>
                <span class="chooser-card__label">{{ choice.label }}</span>
                <i class="fa fa-chevron-right chooser-card__chevron ms-auto" aria-hidden="true"></i>
            </a>
        </div>
    }
</div>
